import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import config from '@monorepo/shared/src/config';

const t = (key: string, options?) => translate('helpAndSupport', key, options);

const HelpAndSupportTiles: React.FC = () => {
  const classes = styles();
  const navigate = useNavigate();

  const tiles = [
    {
      title: t('appTutorial'),
      description: '',
      action: () => navigate({ pathname: '/tour/onboarding' }),
      src: `${config.digitalAssetsUrl}/support/icons/info-icon.png`,
    },
    {
      title: t('supportDocuments'),
      description: '',
      action: () => navigate({ pathname: '/help-and-support/supportDocuments' }),
      src: `${config.digitalAssetsUrl}/icons/downloadable-resource-icon.svg`,
    },
    {
      title: t('trainingVideos'),
      description: '',
      action: () => navigate({ pathname: '/help-and-support/trainingVideos' }),
      src: `${config.digitalAssetsUrl}/support/icons/training-videos-icon.png`,
    },
    {
      title: t('contactUs'),
      description: '',
      action: () => window.open(config.digitalProductSupportUrl, '_blank'),
      src: `${config.digitalAssetsUrl}/support/icons/envelope-icon.png`,
    },
  ];

  return (
    <Box className={classes.box}>
      {tiles.map((tile, index) => (
        <Card className={classes.card} key={index} elevation={4} onClick={tile.action}>
          <Box className={classes.media}>
            <img src={tile.src} alt={tile.title} />
          </Box>
          <CardContent className={classes.content}>
            <Typography variant="h2" className={classes.titie}>
              {tile.title}
            </Typography>
            <Typography
              className={classes.description}
              color="textPrimary"
              component="p"
              variant="subtitle1"
            >
              {tile.description}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default HelpAndSupportTiles;

const styles = makeStyles((theme: any) => ({
  box: {
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fit, ${remCalc(276)})`,
    gridGap: remCalc(24),
    width: '100%',
    justifyContent: 'center',
  },
  card: {
    cursor: 'pointer',
    padding: theme.spacing(6),
    boxSizing: 'border-box',
  },
  media: {
    height: remCalc(228),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      maxHeight: remCalc(128),
    },
  },
  titie: {
    lineHeight: 'normal',
  },
  content: {
    padding: `${theme.spacing(3)} 0 0 0`,
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  description: {
    lineHeight: remCalc(24),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
  },
}));
